<template>
  <div class="login">
    <div class="box">
      <h2 class="title is-4">Image Index</h2>
      <div class="field">
        <label class="label">Username</label>
        <input class="input" type="text" v-model="username" v-on:keyup.enter="login">
      </div>
      <div class="field">
        <label class="label">Password</label>
        <input class="input" type="password" v-model="password" v-on:keyup.enter="login">
      </div>
      <div class="notification is-danger" v-if="errorMessage != ''">
        {{errorMessage}}
      </div>
      <button class="button is-pulled-right is-primary" v-on:click="login" >Login</button>
    </div>
  </div>
</template>
<script>
import rpc from '../rpc.js';
export default {
  computed: {
    login_status() {
      return this.$store.state.logged_in;
    }
  },
  data() {
    return {
      username: "",
      password: "",
      errorMessage: "",
    }
  },
  methods: {
    login() {
      this.errorMessage = "";
      rpc.request('LoginService.Login', {name:this.username, password:this.password}).then(json => {
        if(json.status == 200) {
          localStorage.setItem('loginData', JSON.stringify(json))
          document.cookie = "ii_session_cookie=" + json.token + "; SameSite=Strict";
          this.$store.commit("login", json)
          this.$router.push("/");
        } else {
          this.errorMessage = json.errorMessage;
        }
      })
      //this.$store.commit("login");
      //this.$router.push("/");
    }
  }
};
</script>
